<template>
  <BaseListCard
    title="Reviews"
    :parentId="parentId"
    :parentTitle="parentTitle"
    :options="{ 'reviewStatuses': reviewStatuses,
                'reviewStatusesLoading': reviewStatusesLoading }"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :emptyEntity="emptyEntity"
    :deleteDisabled="deleteDisabled"
    :editDisabled="editDisabled"
    :canAddEntity="canAssignReviews"
    :addLinkLabel="'+ Assign'"
    :initialShowCollapse="false"
    ref="baseCard"
  >
    <template v-slot:addForm="{ newEntity, options, entities, stopAdding, entityCreated }">
      <ReviewForm
        :existingReview="newEntity"
        :reviewStatuses="options.reviewStatuses"
        :storeNamespace="storeNamespace"
        :parentId="parentId"
        @closeForm="stopAdding">
      </ReviewForm>
    </template>
    <template v-slot:editForm="{ entity, options, stopEditing, entityUpdated }">
      <ReviewForm
        :existingReview="entity"
        :reviewStatuses="options.reviewStatuses"
        :storeNamespace="storeNamespace"
        :parentId="parentId"
        @closeForm="stopEditing">
      </ReviewForm>
    </template>
    <template v-slot:entityDetails=" { entity }">
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="list-header">
            Reviewer
          </div>
          <div class="list-details">
            {{ entity.assigneeName }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Assigned By
          </div>
          <div class="list-details">
            {{ entity.assignerName }}
          </div>
        </div>
        <div class="col-sm-2">
          <div class="list-header">
            Open Date
          </div>
          <div class="list-details">
            {{ entity.openDate | dateStringNullIsNA }}
          </div>
        </div>
        <div class="col-sm-2">
          <div class="list-header">
            Close Date
          </div>
          <div class="list-details">
            {{ entity.closeDate | dateStringNullIsNA }}
          </div>
        </div>
        <div class="col-sm-2">
          <div class="list-header">
            Review Status
          </div>
          <div class="list-details">
            {{ getReviewStatusName(entity.reviewStatusId) }}
          </div>
        </div>
      </div>
      <hr>
      <div class="row mb-2">
        <div class="col-6">
          <div class="list-header">
            Review Instructions
          </div>
          <div class="list-details notes-field">{{entity.instructions || 'None'}}</div>
        </div>
        <div class="col-6">
          <div class="list-header">
            Reviewer Comments
          </div>
          <div class="list-details notes-field">{{entity.comments || 'None'}}</div>
        </div>
      </div>
    </template>
  </BaseListCard>
</template>
<script>
import { mapState } from 'vuex';
import CollapseParent from '@/mixins/CollapseParent';
import { EntityModules } from '@/store/moduleConfig';
import BaseListCard from '../common/BaseListCard.vue';
import ReviewForm from './ReviewForm.vue';

export default {
  name: 'ReviewCard',
  props: [
    'parentId',
    'parentType',
    'parentTitle',
    'canAssignReviews',
    'reviewStatuses',
    'reviewStatusesLoading',
    'entities',
    'entitiesLoading',
  ],
  mixins: [CollapseParent],
  components: {
    BaseListCard,
    ReviewForm,
  },
  computed: {
    storeNamespace() {
      if (this.parentType === 'instrument') {
        return EntityModules.INSTRUMENT_REVIEW.namespace;
      }
      return EntityModules.SERVICE_REVIEW.namespace;
    },
    ...mapState('User', {
      user: state => state.user,
    }),
  },
  methods: {
    emptyEntity(parentId) {
      let instrumentId = null;
      let serviceId = null;
      if (this.parentType === 'instrument') {
        instrumentId = parentId;
      } else {
        serviceId = parentId;
      }
      return {
        instrumentId,
        serviceId,
        instructions: null,
      };
    },
    getReviewStatusName(id) {
      const reviewStatus = this.reviewStatuses.filter(p => p.id === id)[0];
      return reviewStatus ? reviewStatus.name : 'None';
    },
    deleteDisabled: () => true,
    editDisabled(entity) {
      return (!entity
              || !(entity.reviewStatusId === 1
              && (this.isUserAdmin() || entity.assigneeId === this.getCurrentUserId()
              || entity.assignerId === this.getCurrentUserId()))
      );
    },
    isUserAdmin() {
      return this.user.idToken.roles.includes('Admin');
    },
    getCurrentUserId() {
      return this.user.idToken.oid;
    },
  },
};
</script>
